/**
 * Reports Types
 */

export interface ReportTemplate {
  id: number;
  name: string;
  report_type: ReportType;
  museum: string;
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export type ReportType = 'periodic_summary' | 'customized_report';

export type DataType = 'tour_reports' | 'concierge_logs' | 'content_reports' | 'robot_utilization' | 'service_reports';

export const DATA_TYPE_LABELS: Record<DataType, string> = {
  tour_reports: 'Guided Tour User Report',
  concierge_logs: 'Concierge Service User Report',
  content_reports: 'Content Report',
  robot_utilization: 'Robot Utilization & Service Report',
  service_reports: 'Service Report',
};

export const REPORT_TYPE_LABELS: Record<ReportType, string> = {
  periodic_summary: 'Periodic Summary',
  customized_report: 'Customized Report',
};

export type ReportSource = 'periodic' | 'customized';

export interface ReportSchedule {
  id: number;
  template: number;
  template_name: string;
  frequency: ScheduleFrequency;
  email_recipients: string[];
  is_active: boolean;
  last_run?: string;
  next_run: string;
  created_at: string;
  updated_at: string;
}

export type ScheduleFrequency = 'daily' | 'weekly' | 'monthly';

export interface GeneratedReport {
  id: number;
  template: number;
  template_name: string;
  report_date: string;
  date_from: string;
  date_to: string;
  museum: string;
  file_path: string;
  file_format: FileFormat;
  file_size: number;
  generated_at: string;
  generated_by: number;
  generated_by_username: string;
  report_source: ReportSource;
}

export type FileFormat = 'csv' | 'pdf';

export interface ReportGenerationRequest {
  report_type: ReportType;
  data_type: DataType;
  report_source: ReportSource;
  museum: string;
  /** Month in YYYY-MM format, e.g. "2025-01" */
  month: string;
  file_format: FileFormat;
}

export interface ReportGenerationResponse {
  success: boolean;
  report_id: number;
  file_path: string;
  file_format: FileFormat;
  file_size: number;
  data: any;
}

export interface ReportStats {
  total_reports: number;
  templates_count: number;
  scheduled_count: number;
  last_generated?: string;
}
